exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel[data-v-1d351b2a]{-webkit-user-select:auto!important;-ms-user-select:auto!important;user-select:auto!important;width:90%!important}.header .header__status.color-light li[data-v-1d351b2a],.header .header__status.color-light li a[data-v-1d351b2a]{color:#a5a5a5;border:0}.header .header__status[data-v-1d351b2a]{height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d351b2a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 67
// module chunks = 0